export type CookieConsent = Record<string, boolean>;

export interface CookieFirst {
    consent: CookieConsent|null,
    acceptCategory: (category: string) => void,
}

let getCookieFirstPromise: Promise<CookieFirst>|null = null;
let onCookieFirstInitialConsentPromise: Promise<CookieConsent>|null = null;

export async function getCookieFirst(): Promise<CookieFirst> {
    if (getCookieFirstPromise === null) {
        getCookieFirstPromise = getCookieFirstImpl();
    }
    return getCookieFirstPromise;
}

export async function getCookieFirstInitialConsent(): Promise<CookieConsent> {
    if (onCookieFirstInitialConsentPromise === null) {
        onCookieFirstInitialConsentPromise = onCookieFirstInitialConsentImpl();
    }
    return onCookieFirstInitialConsentPromise;
}

async function getCookieFirstImpl(): Promise<CookieFirst> {
    const cookieFirstMaybe = getCookieFirstMaybe();
    if (cookieFirstMaybe) {
        return cookieFirstMaybe;
    }

    await new Promise<void>(resolve => {
        window.addEventListener('cf_init', () => {
            resolve();
        }, { once: true });
    });

    return getCookieFirstMaybe()!;
}

async function onCookieFirstInitialConsentImpl(): Promise<CookieConsent> {
    const cookieFirst = await getCookieFirst();
    if (cookieFirst.consent !== null) {
        return cookieFirst.consent;
    }

    return new Promise<CookieConsent>(resolve => {
        window.addEventListener('cf_consent', event => {
            resolve((event as CustomEvent).detail);
        }, { once: true });
    });
}

function getCookieFirstMaybe(): CookieFirst|undefined {
    return (window as any).CookieFirst ?? undefined;
}
